// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navbar_navigation__1ECtc","logo":"navbar_logo__RCwGh","menuItem":"navbar_menuItem__2Xlbf","li":"navbar_li__2PVO_"};